import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-utah-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./utah-state-form.component.html",
  styleUrl: "./utah-state-form.component.scss",
})
export class UtahStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
